import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable, combineLatest, map, mergeMap } from 'rxjs';
import { Clinic } from '../models/clinic.model';
import { Visit } from '../models/visit.model';
import { PetService } from './pet.service';
import { SpecialistService } from './specialist.service';
import { UserService } from './user.service';
import { convertSnaps } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class VisitService {
  constructor(
    private db: AngularFireDatabase,
    private userService: UserService,
    private petService: PetService,
    private specialistService: SpecialistService,
  ) {}

  findVisits(clinic?: Clinic): Observable<Visit[]> {
    return this.db
      .list(`${localStorage.getItem('appId')}_visits`)
      .snapshotChanges()
      .pipe(
        map((results) => convertSnaps<Visit>(results)),
        mergeMap((visits) => {
          const observables = visits.map((visit) => {
            const userObservable = this.userService.findById(visit.patientId);
            const petObservable = this.petService.findById(visit.petId);
            const specialistObservable = this.specialistService.findById(visit.specialistId);

            return combineLatest([userObservable, petObservable, specialistObservable]).pipe(
              map(([user, pet, specialist]) => {
                visit.patient = user;
                visit.pet = pet;
                visit.specialist = specialist;
                return visit;
              }),
            );
          });

          return combineLatest(observables);
        }),
        map((visits) => visits.filter((visit) => !!visit.specialist && !!visit.specialist.name)),
        map((visits) => {
          if (clinic) {
            return visits.filter((visit) => visit.patient.clinicId === clinic.id);
          }
          return visits;
        }),
      );
  }
}
